import * as React from 'react';
import * as _ from 'lodash';
import { TabsList, TabsContainer, TabListItem, TabItemText, TabItemUnderline, TabGeneralUnderline } from './styles';
import { SIZE } from 'common/sizes';
import { parentPort } from 'worker_threads';

export interface TabItem {
    displayName: string;
    internalName: string;
    selected: boolean;
    disabled?: boolean;
    uppercase?:boolean;
    style?:any;    

}

export interface TabsProps {
    tabItems: TabItem[]
    style?:any
    styleUnderline?:any;
    onClickTabItem: (tabItem: TabItem) => void
    renderTabItem?: (tabItem: TabItem) => JSX.Element
}

export interface TabsState {
    width: number,
    moveTo: number,
    selectedIndex: number
}

function tabsReducer(state: TabsState, action) {
    const { width, moveTo, selectedIndex } = action
    return {
        width,
        moveTo,
        selectedIndex
    }
}

const Tabs = (props: TabsProps) => {

    const refIds = React.useRef<HTMLElement[]>([]);
    const [state, dispatch]: [TabsState, any] = React.useReducer(tabsReducer, {
        width: 0,
        moveTo: 0,
        selectedIndex: -1
    });

    React.useEffect(() => {
        const selectedIndex = _.findIndex(props.tabItems, { selected: true });
        if (!_.isEqual(state.selectedIndex, selectedIndex)) {
            calculateTabItemUnderline()
        } else if (selectedIndex === -1) {
            calculateTabItemUnderline()
        }

    }, [props.tabItems])


    return (
        <TabsContainer style={props.style}>
            <TabsList>
                {
                    props.tabItems.map((tabItem, index) => renderTabItem(tabItem, index))
                }
            </TabsList>
            <TabGeneralUnderline  />
            <TabItemUnderline
                moveTo={state.moveTo}
                width={state.width}
                style={props.styleUnderline}
            />
        </TabsContainer>
    );


    function calculateTabItemUnderline() {
        const selectedIndex = _.findIndex(props.tabItems, { selected: true });
        const width = refIds.current[selectedIndex] ? refIds.current[selectedIndex].clientWidth: 0;            
        const moveTo = refIds.current.reduce((acc, currentElement, index) => {
            if (index < selectedIndex) {
                return acc + currentElement.clientWidth + SIZE.FOUR;
            }
            return acc + 0;
        }, SIZE.THREE);
        dispatch({
            width,
            moveTo,
            selectedIndex
        });
    }

    function renderTabItem(tabItem: TabItem, index) {
        const isDisabled = tabItem.disabled ? tabItem.disabled : false;
        return (
            <TabListItem
                key={tabItem.internalName}
                onClick={() => props.onClickTabItem(tabItem)}
                disabled={isDisabled}
            >
                {
                    props.renderTabItem
                        ?
                        props.renderTabItem(tabItem)
                        :
                        <TabItemText ref={refHandler} isSelected={tabItem.selected} disabled={isDisabled} style={tabItem.style}>
                            {
                                tabItem.uppercase??false ?
                                tabItem.displayName.toLocaleUpperCase()
                                :
                                tabItem.displayName
                            }
                        </TabItemText>
                }
            </TabListItem>
        )
    }

    function refHandler(node) {
        refIds.current.push(node);
    }

}

export default Tabs;
